import EventEmitter from 'event-emitter';
import log from 'loglevel';
import allOff from 'event-emitter/all-off';

/**
 * 万物之源
 *
 * @export
 * @class Component
 */
export default class Component {
  constructor() {
    EventEmitter(this);
    this.CLASS_NAME = this.constructor.name;
  }

  /**
   * 销毁操作
   *
   * @memberof Component
   */
  destroy() {}

  removeAllEvents() {
    allOff(this);
  }
}
